// File: noviopus-ats-client/src/components/PromptDialog/index.tsx
import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '@/components/Button';
import { closePromptDialog } from './actions';
import { StyleManagerContext } from '@/styles/StyleManagerContext';
import { safeGetIn } from '@/utils/safeImmutable'; 

// Legacy imports
import Dialog from '@/components/Dialog';
import XIcon from '@/components/icons/XIcon';
import cx from 'classnames';

const WIDTH = 400;

import {
  styleSheet as originalStyleSheet,
  buttonCancelLabelStyle,
  buttonCancelStyle,
  buttonSaveLabelStyle,
  buttonSaveStyle,
} from './styleSheet';

export const styleSheet = originalStyleSheet;

const PromptDialog: React.FC = (props) => {
  const dispatch = useDispatch();
  
  // FIX: Access state safely (Root POJO -> Prompt Immutable Map)
  const open = useSelector((state: any) => safeGetIn(state, ['prompt', 'open']));
  const message = useSelector((state: any) => safeGetIn(state, ['prompt', 'message']));
  const rawOptions = useSelector((state: any) => safeGetIn(state, ['prompt', 'options']));

  // FIX: Ensure options is a Plain JS Object for destructuring
  const options = (rawOptions && typeof rawOptions.toJS === 'function') 
    ? rawOptions.toJS() 
    : rawOptions;

  const handleButtonClick = (result: boolean | null) => {
    dispatch(closePromptDialog(result));
  };

  const { styleManager } = useContext(StyleManagerContext);
  const classes = styleManager.render(styleSheet);
  
  const { yesLabel, noLabel } = options || { yesLabel: 'Yes', noLabel: 'No' };

  const rootClasses = {
    'cy-dialog': true,
    [`${classes.root}`]: true,
  };

  const buttonYes = {
    [`${classes.displayNone}`]: !yesLabel,
    'cy-dialog-restore-activity': true,
  };

  const buttonNo = {
    [`${classes.displayNone}`]: !noLabel,
    'cy-dialog-dont-restore-activity': true,
  };

  const safeMessage = message || '';
  const contentStyle = {
    display: 'flex',
    justifyContent: 'center',
    width: safeMessage.length < 200 ? WIDTH : WIDTH * 1.3,
  };

  return (
    <Dialog
      autoScrollBodyContent={true}
      contentStyle={contentStyle}
      bodyStyle={{ padding: 0, color: '#757575', display: 'flex', flexGrow: '1' }}
      autoDetectWindowHeight={false}
      modal={true}
      onRequestClose={() => handleButtonClick(null)}
      open={!!open}
      className={cx(rootClasses)}
    >
      <div className={classes.contentContainer}>
        <Button
          icon={<XIcon />}
          style={{ alignSelf: 'flex-end', padding: 0, width: '38px', height: '38px' }}
          onClick={() => handleButtonClick(null)}
        />
        <div className={classes.title}>
          {typeof safeMessage === 'string'
            ? safeMessage
            : safeMessage.map((m: string, i: number) => (
                <div key={i}>
                  <span>{m}</span>
                  <br />
                </div>
              ))}
        </div>
        <div className={classes.buttonsContainer}>
          <Button
            label={yesLabel}
            style={buttonSaveStyle}
            labelStyle={buttonSaveLabelStyle}
            hoverColor="#00AAA6"
            className={cx(buttonYes)}
            backgroundColor="#1AC5C0"
            onClick={() => handleButtonClick(true)}
          />
          <Button
            label={noLabel}
            style={buttonCancelStyle}
            labelStyle={buttonCancelLabelStyle}
            hoverColor="#E6F9F9"
            className={cx(buttonNo)}
            backgroundColor="#FFF"
            onClick={() => handleButtonClick(false)}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default PromptDialog;